/**
 * Convert a raw file size into a human readable format
 * @param size number
 * @returns string
 */
export function fileSizeToHumanReadable(size: number): string {
	if (size === 0) return '0 Bytes'

	const k = 1024
	const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
	const i = Math.floor(Math.log(size) / Math.log(k))

	return parseFloat((size / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
}
